import api from '../config/api';
import { Invitation, SendInvitationsData } from '../types';

export const invitationService = {
  // Send invitations
  sendInvitations: async (data: SendInvitationsData): Promise<{ success: boolean; message: string }> => {
    const response = await api.post('/invitations/send', data);
    return response.data;
  },

  // Get raffle invitations
  getRaffleInvitations: async (raffleId: string): Promise<{ success: boolean; data: Invitation[] }> => {
    const response = await api.get(`/invitations/raffle/${raffleId}`);
    return response.data;
  },

  // Resend invitation
  resendInvitation: async (id: string): Promise<{ success: boolean; message: string }> => {
    const response = await api.post(`/invitations/${id}/resend`);
    return response.data;
  },

  // Delete invitation
  deleteInvitation: async (id: string): Promise<{ success: boolean; message: string }> => {
    const response = await api.delete(`/invitations/${id}`);
    return response.data;
  },

  // Get received invitations
  getReceivedInvitations: async (): Promise<{ success: boolean; data: Invitation[] }> => {
    const response = await api.get('/invitations/received');
    return response.data;
  },

  // Accept invitation
  acceptInvitation: async (id: string): Promise<{ success: boolean; message: string }> => {
    const response = await api.post(`/invitations/${id}/accept`);
    return response.data;
  },

  // Decline invitation
  declineInvitation: async (id: string): Promise<{ success: boolean; message: string }> => {
    const response = await api.post(`/invitations/${id}/decline`);
    return response.data;
  },

  // Add raffle by code
  addCodeRaffle: async (data: { raffleId: string; accessCode: string }): Promise<{ success: boolean; message: string }> => {
    const response = await api.post('/invitations/code/add', data);
    return response.data;
  },

  // Remove raffle by code
  removeCodeRaffle: async (raffleId: string): Promise<{ success: boolean; message: string }> => {
    const response = await api.delete(`/invitations/code/${raffleId}`);
    return response.data;
  },

  // Get code raffles
  getCodeRaffles: async (): Promise<{ success: boolean; data: any[] }> => {
    const response = await api.get('/invitations/code/raffles');
    return response.data;
  },
};
